import { render, staticRenderFns } from "./ProductSubstituitionData.vue?vue&type=template&id=421bc29d&"
import script from "./ProductSubstituitionData.vue?vue&type=script&lang=js&"
export * from "./ProductSubstituitionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports